import { useEffect, useState } from "react";
import moment from "moment";

import { useStateContext } from "../../contexts/ContextProvider";

// components
import DashboardGreeting from "../DashboardGreeting";

// svg icons
import SearchIcon from "../../assets/images/search.svg";
import FilterIcon from "../../assets/images/filter.svg";
import ExportIcon from "../../assets/images/export.svg";
import { Empty, Flex, Skeleton } from "antd";
import DataTableComponent from "../Charts/DatatableComponent";
import LeaveHistoryService from "../../services/leaveHistory.service";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";

import { Calendar as MonthCalendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";

const LeaveReconcile = ({ user }) => {
  const navHeading = "Leave Reconcile";

  const [data, setData] = useState([]);

  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const [loading, setLoading] = useState(false);

  const currentDate = new Date();
  const maxDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1,
  );

  const [date, setDate] = useState(currentDate);
  const [year, setYear] = useState(currentDate);

  const [details, setDetails] = useState({
    month: currentDate.getMonth() + 1,
    year: currentDate.getFullYear(),
  });

  const columns = [
    {
      name: "Emp Name",
      selector: (row) => row.name,
      cell: (row) => (
        <>
          <div className="emp-info">
            <span>
              <svg
                width="17"
                height="17"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.9993 0C8.50756 0 6.48047 2.02709 6.48047 4.51881C6.48047 7.01052 8.50756 9.03762 10.9993 9.03762C13.491 9.03762 15.5181 7.01052 15.5181 4.51881C15.5181 2.02709 13.491 0 10.9993 0ZM10.9993 6.87723C9.69878 6.87723 8.64085 5.8193 8.64085 4.51881C8.64085 3.21832 9.69878 2.16038 10.9993 2.16038C12.2998 2.16038 13.3577 3.21832 13.3577 4.51881C13.3577 5.8193 12.2998 6.87723 10.9993 6.87723Z"
                  fill="#4E465E"
                />
                <path
                  d="M11.0002 11.198C6.43383 11.198 2.71875 14.9131 2.71875 19.4795C2.71875 20.0761 3.20241 20.5597 3.79894 20.5597H9.92005V20.9198C9.92005 21.5163 10.4037 22 11.0002 22C11.5968 22 12.0804 21.5163 12.0804 20.9198V20.5597H18.2016C18.7981 20.5597 19.2817 20.076 19.2817 19.4795C19.2817 14.9131 15.5667 11.198 11.0002 11.198ZM9.92005 18.3993H4.97457C5.42359 15.8883 7.40913 13.9032 9.92005 13.4543V18.3993ZM12.0804 18.3993V13.4543C14.5914 13.9032 16.5769 15.8883 17.0259 18.3993H12.0804V18.3993Z"
                  fill="#4E465E"
                />
              </svg>
            </span>
            <div className="flex-column">
              <span>{row.name}</span>
              {/* <span className="code">{row.name}</span> */}
            </div>
          </div>
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "From Date",
      selector: (row) => row.fromDate,
      cell: (row) => {
        return (
          <>
            <span
              title={row.fromDate}
            >
              {row.fromDate}
            </span>
          </>
        );
      },
      sortable: true,
    },
    {
      name: "To Date",
      selector: (row) => row.toDate,
      cell: (row) => {
        return (
          <>
            <span
              title={row.toDate}
            >
              {row.toDate}
            </span>
          </>
        );
      },
      sortable: true,
    },
    {
      name: "Leave Days",
      selector: (row) => row.leaveDays,
      sortable: true,
    },
    {
      name: "LOP Days",
      selector: (row) => row.lopDays,
      sortable: true,
    },
    {
      name: "View Details",
      // selector: (row) => row.description?.replaceAll(/<br\s*\/?>/gi, " "),
      selector: (row) => {
        let text = row.description || "";

        // Remove <br>, <br/>, <br />
        text = text.replace(/<br\s*\/?>/gi, " ");

        // Remove ALL HTML tags (optional but usually needed)
        text = text.replace(/<[^>]+>/g, " ");

        // Convert &amp; → &
        text = text.replace(/&amp;/g, "&");

        // Remove extra spaces (multiple → single)
        text = text.replace(/\s+/g, " ").trim();

        return text;
      },
      cell: (row) => (
        <>
          <Link
            to={"/leaveReconcileDetails"}
            state={{ rowData: row, redirectBack: "/leaveReconcile" }}
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-eye"
                viewBox="0 0 16 16"
              >
                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
              </svg>
            </span>
          </Link>
        </>
      ),
      sortable: true,
      omitFromExport: true,
    },
  ];


  const handleDateChange = (e) => {
    setDate(e.value);

    if (!e.value) {
      // Clear filter logic
      setDetails({
        month: "",
        year: "",
      });

      // Optionally, fetch unfiltered leave request count
      if (user.role !== "1" || user.role !== "4") {
        fetchData("", "");
      }
      return;
    }

    const month = moment(new Date(e.value)).format("M");
    const year = moment(new Date(e.value)).format("YYYY");

    if (user.role !== "1" || user.role !== "4") {
      fetchData(month, year);
    }

    setDetails((prevState) => ({
      ...prevState,
      month: month,
    }));
  };

  const handleYearChange = (e) => {
    setYear(e.value);

    if (!e.value) {
      // Clear filter logic
      setDetails({
        month: "",
        year: "",
      });
      // Optionally, fetch unfiltered leave request count
      if (user.role !== "1" || user.role !== "4") {
        fetchData( "", "");
      }
      return;
    }

    const year = moment(new Date(e.value)).format("YYYY");

    const payload = {
      month: details.month ? details.month : "",
      year: year,
    };
    if (user.role !== "1" || user.role !== "4") {
      fetchData(payload.month, payload.year);
    }

    setDetails((prevState) => ({
      ...prevState,
      year: year,
    }));
  };

  const handleSearch = (e) => {
    const keyword = e.target.value.toLowerCase();
    setSearch(e.target.value);
    const filteredData = data.filter(
      (row) =>
        (row.empName && row.empName.toLowerCase().includes(keyword)) ||
        (row.name && row.name.toLowerCase().includes(keyword)) ||
        (row.emp_id && row.emp_id.toLowerCase().includes(keyword)),
    );
    if (keyword.length > 0) {
      setFilter(true);
    } else {
      setFilter(false);
    }
    setFilteredData(filteredData);
  };

  const fetchData = (month, year) => {
    const payload = {
      empid: "",
      month: month,
      year: year,
    };

    LeaveHistoryService.getReconciliationReq(payload)
      .then((resp) => {
        if (resp.data) {
          setData(resp.data);
        }
      })
      .catch((e) => {
        console.log(e);
        setData([]);
      });
  };

  useEffect(() => {
    fetchData(details.month, details.year);
  }, []);

  const exportToExcel = (e, columns, data, reportName) => {
    const formattedData = data.map((row) => {
      const formattedRow = {};

      columns.forEach((col) => {
        let value;

        if (col.omitFromExport) return;

        // If selector exists
        if (typeof col.selector === "function") {
          value = col.selector(row);

          // Convert JSX / React element to text
        } else {
          value = row[col.name];
        }

        formattedRow[col.name] = value;
      });

      return formattedRow;
    });

    const fileName = filter ? "" : "";

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${reportName}.xlsx`);
  };

  return (
    <>
      <div className="dashboard-container hr">
        <DashboardGreeting navHeading={navHeading} user={user} />

        <div className="filterBarNew mb-3">
          <div className="d-flex">
            <div className="searchBar">
              <input
                type="text"
                placeholder="Search Employee name/ID"
                value={search}
                onChange={handleSearch}
              />
              <span>
                <img src={SearchIcon} alt="" />
              </span>
            </div>
          </div>

          <div className="filter topbar">
            <div className="sort-filter filter">
              <div className="new-calendar-type flex justify-content-center month-year">
                <Flex gap={10}>
                  <MonthCalendar
                    value={date}
                    onChange={handleDateChange}
                    view="month"
                    placeholder="Select Month"
                    dateFormat="MM"
                    style={{ width: "100%" }}
                    showIcon
                    showButtonBar
                    yearNavigator={false}
                    monthNavigator={true}
                    panelClassName="month-only-calendar"
                  />
                  <MonthCalendar
                    value={year}
                    onChange={handleYearChange}
                    view="year"
                    placeholder="Select Year"
                    dateFormat="yy"
                    style={{ width: "100%" }}
                    showIcon
                    maxDate={maxDate}
                    showButtonBar
                  />
                </Flex>
              </div>

              {/* <div className="filter" onClick={showFilter}>
                <img src={FilterIcon} alt="" />
              </div> */}
              <div
                className="export"
                onClick={(e) => {
                  exportToExcel(
                    e,
                    columns,
                    filter ? filteredData : data,
                    "Leave Reconcile Applications",
                  );
                }}
              >
                <span>
                  <img src={ExportIcon} alt="" />
                </span>
                <span>Export</span>
              </div>
            </div>
          </div>
        </div>

        <div className="">
          {loading ? (
            <>
              <Skeleton active={loading} />
            </>
          ) : (filter ? filteredData : data).length === 0 ? (
            <>
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </>
          ) : (
            <>
              <DataTableComponent
                columns={columns}
                data={filter ? filteredData : data}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default LeaveReconcile;
